import { socialNetworksMediaProductTypes } from 'views/calendar/SocialNetworkSidePanel';

export const TIKTOK_PRIVACY_LEVELS = [
    { value: 'PUBLIC_TO_EVERYONE', label: 'public' },
    { value: 'MUTUAL_FOLLOW_FRIENDS', label: 'friends' },
    { value: 'SELF_ONLY', label: 'private' },
    { value: 'FOLLOWER_OF_CREATOR', label: 'followers' },
];

export const TIKTOK_PRIVACY_ALIASES = {
    public: 'PUBLIC_TO_EVERYONE',
    public_to_everyone: 'PUBLIC_TO_EVERYONE',
    everyone: 'PUBLIC_TO_EVERYONE',
    friends: 'MUTUAL_FOLLOW_FRIENDS',
    mutual_follow_friends: 'MUTUAL_FOLLOW_FRIENDS',
    mutual: 'MUTUAL_FOLLOW_FRIENDS',
    private: 'SELF_ONLY',
    self_only: 'SELF_ONLY',
    only_me: 'SELF_ONLY',
    followers: 'FOLLOWER_OF_CREATOR',
    follower_of_creator: 'FOLLOWER_OF_CREATOR',
};

export const BASELINE_COLUMNS = [
    {
        name: 'content',
        required: true,
        description: 'Post message / body text',
        example: 'Your post text here',
    },
    {
        name: 'title',
        required: false,
        description: 'Optional title — used by Pinterest, YouTube, Medium',
        example: 'Optional title',
    },
    {
        name: 'link',
        required: false,
        description: 'Optional URL attached to the post',
        example: 'https://yoursite.com',
    },
    {
        name: 'media_urls',
        required: false,
        description: 'Comma-separated image / video URLs (use quotes around the cell)',
        example: 'https://img1.jpg,https://img2.jpg',
    },
    {
        name: 'year',
        required: false,
        description: 'Schedule year (e.g. 2026). Leave year/month/day blank to auto-queue.',
        example: '2026',
    },
    {
        name: 'month',
        required: false,
        description: 'Schedule month, 1–12',
        example: '6',
    },
    {
        name: 'day',
        required: false,
        description: 'Schedule day of month, 1–31',
        example: '15',
    },
    {
        name: 'hour',
        required: false,
        description: 'Schedule hour, 0–23 (24-hour clock, your timezone)',
        example: '10',
    },
    {
        name: 'minute',
        required: false,
        description: 'Schedule minute, 0–59 (defaults to 0 if blank)',
        example: '0',
    },
    {
        name: 'first_comment',
        required: false,
        description: 'Optional first comment auto-posted after publish',
        example: 'Thanks for reading!',
    },
];

export const SCHEDULE_COLUMN_NAMES = ['year', 'month', 'day', 'hour', 'minute'];

export const getMediaProductTypeColumnDef = (networks) => {
    const showsMediaProductType = networks.some((n) =>
        (socialNetworksMediaProductTypes[n] || []).length > 1
    );
    if (!showsMediaProductType) return null;
    const allowedValues = Array.from(new Set(
        networks.flatMap((n) => socialNetworksMediaProductTypes[n] || [])
    ));
    return {
        name: 'media_product_type',
        required: false,
        description: `Optional. One of: ${allowedValues.join(' | ')}. Defaults to FEED.`,
        example: 'FEED',
        allowedValues,
    };
};

export const getPinterestBoardColumnDef = (networks) => {
    if (!networks.includes('pinterest')) return null;
    return {
        name: 'pinterest_board',
        required: false,
        description: 'Pinterest board name or numeric ID. Defaults to first board.',
        example: 'My Travel Board',
    };
};

export const getTiktokPrivacyColumnDef = (networks) => {
    if (!networks.includes('tiktok')) return null;
    return {
        name: 'tiktok_privacy_level',
        required: false,
        description: `TikTok privacy. One of: public | friends | private | followers. Defaults to public.`,
        example: 'public',
    };
};

export const getAllColumnDefs = (networks) => {
    return [
        ...BASELINE_COLUMNS,
        getMediaProductTypeColumnDef(networks),
        getPinterestBoardColumnDef(networks),
        getTiktokPrivacyColumnDef(networks),
    ].filter(Boolean);
};
